import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeState, Theme } from '../types';

const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',

      setTheme: (newTheme: Theme) => {
        set({ theme: newTheme });
        // Apply theme to document root
        document.documentElement.setAttribute('data-theme', newTheme);
      },

      toggleTheme: () => {
        const { theme, setTheme } = get();
        const newTheme: Theme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
      },

      // Initialize theme on store creation
      initTheme: () => {
        const { theme } = get();
        document.documentElement.setAttribute('data-theme', theme);
      }
    }),
    {
      name: 'theme-storage',
      partialize: (state) => ({
        theme: state.theme
      })
    }
  )
);

export default useThemeStore;
